import React, { useEffect } from 'react';
import styled from 'styled-components';
import PaginatedReactDropdown from "../dropdown";
import Input from "sushiweb/InputTypes/Input";
import ResourceCardHeader from './ResourceHeader'

const entityOptions = [
  { key: "*", label: "All" },
  { key: "User", label: "User" },
  { key: "Locality", label: "Locality" },
  { key: "City", label: "City" },
  { key: "Country", label: "Country" },
  { key: "", label: "Global" },
];

const entityKeyToOption = {
  "*": entityOptions[0].label,
  "User": entityOptions[1].label,
  "Locality": entityOptions[2].label,
  "City": entityOptions[3].label,
  "Country": entityOptions[4].label,
  "": entityOptions[5].label,
}

const ACCESS_LIST_MAP =  {
  "none": 0,
  "read": 1,
  "write": 2,
  "admin": 4,
  "delete": 3
}

const lineStyle = {
  width: '100%',
  marginBottom: '1rem',
  border: '0',
  borderTop: '1px solid #ddd',
};

const ResourceCard = (props) => {
  const resourceName = props.resourceName;
  const [namespaces, setNamespaces] = React.useState([]);
  const [keys, setKeys] = React.useState([]);
  const [namesapce, setNamespace] = React.useState(props.namesapce);
  const [access, setAccess] = React.useState(props.access);
  const parts = props?.pattern?.split("/") || []
  const initialConfigState = {
    entity: "*",
    entityId: "*",
    keyOptions: [],
  }
  if (parts.length > 0) {
    initialConfigState.namespace = parts[0];
    initialConfigState.key = parts[1];
    if (parts.length > 2) {
      const hierarchyPart = parts[2] || "";

      if (hierarchyPart.includes("#")) {
        initialConfigState.entity = hierarchyPart?.split("#")[0];
        initialConfigState.entityId = hierarchyPart?.split("#")[1];
      }
    }
    if (initialConfigState.key == "*") {
      initialConfigState.keyOptions.push({ key: "*", label: "All" });
      initialConfigState.key = "All"
    }

  }

  const [configState, setConfigState] = React.useState(initialConfigState)
  const [entity, setEntity] = React.useState(initialConfigState.entity);
  const [entityId, setEntityId] = React.useState(initialConfigState.entityId);

  const handleStatusChange = (key, val) => {
    setConfigState({
      ...configState,
      [key]: val,
    });

    let configKey = configState.key, entity = configState.entity, entityId = configState.entityId;

    if (key == "key") {
      configKey = val;
    }
    if (key == "entity") {
      entity = val;
      setEntity(val);
    }

    if (key == "entityId") {
      entityId = val;
      setEntityId(val);
    }

    if (resourceName == "config") { 
      const newResource = {
        name: props.resource.name,
        pattern: `${getResourceNamespace(namesapce)}/${getResourceKey(configKey)}/${entity == "*" ? "*" : `${entity}#${entityId}`}`
      }
      props.handlePolicyUpdate(props.id, props.type, {
        resource: newResource,
        access: ACCESS_LIST_MAP[access.toLowerCase()]
      });
    } else {
      const newResource = {
        name: props.resource.name,
        pattern: getResourceNamespace(namesapce)
      }
     props.handlePolicyUpdate(props.id, props.type, {
        resource: newResource,
        access: ACCESS_LIST_MAP[access.toLowerCase()]
    });
    }

  };



  const getResourceNamespace = (namespace) => {
    if (namespace == "*" || namespace == "" || namespace == undefined || namespace == "All") {
      return "*"
    }
    return namespace
  }

  const getResourceKey = (key) => {
    if (key == "*" || key == "All" || key == undefined || key == "") {
      return "*"
    }
    return key
  }

  const handleChildChange = (key, val) => {
    if (key == "namespace") {
      setNamespace(val);
      if (resourceName == "config") { 
        const newResource = {
          name: props.resource.name,
          pattern: `${val}/${getResourceKey(configState.key)}/${entity == "*" ? "*" : `${entity}#${entityId}`}`
        }
        props.handlePolicyUpdate(props.id, props.type, {
          resource: newResource,
          access: ACCESS_LIST_MAP[access.toLowerCase()]
        });
      }
      if (resourceName == "namespace") {
        const newResource = {
          name: props.resource.name,
          pattern: getResourceNamespace(val)
        }
        props.handlePolicyUpdate(props.id, props.type, {
          resource: newResource,
          access: ACCESS_LIST_MAP[access.toLowerCase()]
        });
      }
    } else if (key == "access") {
      setAccess(val);
      if (resourceName == "config") {
        const newResource = {
          name: props.resource.name,
          pattern: `${getResourceNamespace(namesapce)}/${getResourceKey(configState.key)}/${entity == "*" ? "*" : `${entity}#${entityId}`}`
        }
        props.handlePolicyUpdate(props.id, props.type, {
          resource: newResource,
          access: ACCESS_LIST_MAP[val.toLowerCase()]
        });
      } else {
        const newResource = {
          name: props.resource.name,
          pattern: getResourceNamespace(namesapce)
        }
        props.handlePolicyUpdate(props.id, props.type, {
          resource: newResource,
          access: ACCESS_LIST_MAP[val.toLowerCase()]
        });
      }

    }

    
  }

  const getGlobalCard = (props) => {
    return (
      <CardContainer>
        <ResourceCardHeader
          resourceName="global"
          id={props.id}
          userAccess={props.access}
          type={props.type}
          handlePolicyUpdate={props.handlePolicyUpdate}
          handleRemove={props.handleRemove}
          handleChildChange={handleChildChange} />
      </CardContainer>
    )
  }
  useEffect(() => {
    if (namespaces.length === 0) {
      props.getNamespaces().then((namespaceResponse) => {
        const allNamespaces = namespaceResponse?.namespaces?.map((namespace) => {
          return { key: namespace.namespace, label: namespace.namespace }
        }) || []
        allNamespaces.push({ key: "*", label: "All" })
        setNamespaces(allNamespaces)
      })
    }
  }, []);

  useEffect(() => {
    if (namesapce != "*" && namesapce != "" && namesapce != undefined) {
      props.getKeys(namesapce).then((keyResponse) => {
        const allKeys = keyResponse?.keys?.map((key) => {
          return { key: key, label: key }
        }) || []
        allKeys.push({ key: "*", label: "All" })
        setKeys(allKeys)
      })
    }
  }, [namesapce]);

  const getNamespaceCard = (props) => {

    return (
      <CardContainer>
        <ResourceCardHeader
          namespaces={props?.namespaces}
          resourceName={props?.resourceName}
          userAccess={props?.access}
          id={props.id}
          namespace={props?.namespace}
          type={props.type}
          handlePolicyUpdate={props.handlePolicyUpdate}
          handleChildChange={handleChildChange}
          handleRemove={props.handleRemove}
        />
      </CardContainer>
    )
  };

  const getConfigCard = (props) => {
    return (
      <CardContainer>
        <ResourceCardHeader
          type={props.type}
          id={props.id}
          namespaces={props.namespaces}
          resourceName={props.resourceName}
          userAccess={props.access}
          handlePolicyUpdate={props.handlePolicyUpdate}
          namespace={initialConfigState.namespace}
          handleChildChange={handleChildChange}
          handleRemove={props.handleRemove}
        />
        <hr style={lineStyle}></hr>

        <div style={{ display: 'flex', justifyContent: 'space-between', width: '400px' }}>
          <div style={{ width: 'auto', paddingLeft: '10px' }}>

            <PaginatedReactDropdown
              options={keys}
              labelKey="label"
              valueKey="key"
              handleChange={handleStatusChange}
              keyToChange="key"
              placeholder="Key"
              showCross={false}
              id="fileTypeDropdown"
              showPagination={false}
              value={initialConfigState.key}
            />
          </div>
          <div style={{ width: 'auto', paddingLeft: '10px', fontSize: '12px' }}>
            <PaginatedReactDropdown
              options={entityOptions}
              labelKey="label"
              valueKey="key"
              handleChange={handleStatusChange}
              keyToChange="entity"
              placeholder="Entity"
              showCross={false}
              id="resourceEntityDropDown"
              showPagination={false}
              value={entityKeyToOption[initialConfigState.entity]}
              data-testid="resourceEntity"
            />
          </div>

          {(entity != "*" && entity != "") && <div style={{ width: 'auto', paddingLeft: '10px', fontSize: '12px' }}>
            <Input
              style={{ width: '5rem' }}
              value={entityId}
              data-testid="key"
              id="sushi-input"
              label="ID"
              onChange={(e) => handleStatusChange("entityId", e)}
            />
          </div>}
        </div>


      </CardContainer>
    )
  };

  switch (resourceName) {
    case "*": return getGlobalCard({ ...props });
    case "namespace": return getNamespaceCard({ ...props, namespaces: namespaces });
    case "config": return getConfigCard({ ...props, namespaces: namespaces, keys: keys });
    default: return (<></>)
  }
};

const CardContainer = styled.div`
  width: 400px;
  border-radius: 16px;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
`;

export default ResourceCard;
